export type Locale = "cs" | "en";

export const translations = {
  cs: {
    nav: {
      about: "O mně",
      
      achievements: "Úspěchy",
      blog: "Blog",
      lectures: "Přednášky",
      sales: "Prodej",
      partners: "Spolupráce",
      zebbie: "ZEBBIE",
      community: "Komunita",
      subscribe: "Odebírat",
    },
    hero: {
      subtitle: "Chovatel · Posuzovatel · Cestovatel",
      description: "\"Chovatelství mám v genech!\" Svět exotického ptactva je mou vášní. Chovám, posuzuji, cestuji a sdílím zkušenosti z celého světa.",
      cta: "Přidej se ke komunitě",
      more: "Více o mně",
    },
    about: {
      label: "O mně",
      title1: "Více než 16 let",
      title2: "mezi ptáky",
      p1: "Jsem Tomáš Strachota — chovatel exotického ptactva, posuzovatel výstav a vášnivý cestovatel. Specializuji se na chov výstavních zebřiček pestrých v různých mutacích a můj chov vždy doplňuje pár dalších druhů. Momentálně jsou jimi stříbrozobky zpěvné, které poslední dobou zažívají velký „boom“ i vzhledem k možnostem mutací a kombinací, agapornisové škraboškoví, kteří se po letech vrátili zpět do mého chovu, a papoušci horští.",
      p2: "Zebřičky se dostaly do mého chovu v roce 2014, tedy tři roky po stavbě prvních voliér. U dosud chovaných ptáků mi vadilo, že šlo především o odchov a následný prodej a že nemám žádný stanovený cíl. Díky sérii článků o výstavních zebřičkách jsem se k nim dostal a postupně se od čtyř párů rozrostl ke zhruba 30 chovným klecím a několika voliérám.",
      p3: "V říjnu 2025 jsem odletěl splnit si sen do Austrálie, kde je mým cílem vidět co nejvíce druhů ve volné přírodě. Mé cesty po Austrálii mi daly unikátní pohled na život exotických ptáků v jejich přirozeném prostředí. Během ročního pobytu se podívám do všech států Austrálie a o mých cestách vznikají zápisky, které najdete publikované v časopisech a zde na webu v sekci Blog.",
      p4: "Pravidelně přispívám do časopisu Nová Exota a dalších časopisů, spolupracuji s platformou Birdifly a jsem ambasadorem e-shopu Ornity.cz a značky BirdSupreme.",
    },
    achievements: {
      label: "Úspěchy",
      title1: "Chovatelské",
      title2: "milníky",
      stats: [
        { value: "16+", label: "Let zkušeností" },
        { value: "1000+", label: "Odchovaných mláďat" },
        { value: "15+", label: "Chovaných druhů" },
        { value: "30+", label: "Výstav" },
      ],
      highlights: [
        { title: "Chovatel", description: "Exotickému ptactvu se věnuji od roku 2011, kdy jsem v mých jedenácti letech začal chovat agapornisy a australské papoušky. Od té chvíle je chovatelství součástí mého každodenního života." },
        { title: "Posuzovatel", description: "Na základě úspěchů na výstavách a chuti se dále vzdělávat jsem absolvoval vzdělávací kurz a od roku 2024 se účastním výstav v České republice i v zahraničí jako posuzovatel." },
        { title: "Cestovatel", description: "Návštěvy chovatelů a cestování za výstavami a burzami po celé Evropě a chuť plnit si sny vyústila v mou roční cestu do Austrálie a na Nový Zéland. Své zážitky sdílím v rámci přednášek a článků." },
      ],
    },
    blog: {
      label: "Blog",
      title1: "Nejnovější",
      title2: "články",
      allArticles: "Všechny články",
      read: "Číst",
    },
    lectures: {
      label: "Přednášky",
      title1: "Kde se",
      title2: "potkáme",
      orderLecture: "Objednat přednášku",
      noUpcoming: "Momentálně není naplánovaná žádná přednáška otevřená veřejnosti. Sledujte tuto stránku nebo se přihlaste k odběru novinek, aby vám žádný termín neunikl.",
      items: [] as { title: string; description: string; location: string; date: string }[],
    },
    media: {
      label: "Média",
      title1: "Rozhovory &",
      title2: "reportáže",
      view: "Zobrazit",
    },
    partners: {
      label: "Spolupráce",
      title1: "Projekty &",
      title2: "partneři",
      visit: "Navštívit",
    },
    sales: {
      label: "Prodej",
      title1: "Poptávka",
      title2: "ptáků",
      heroText: "Máte zájem o odchovy z mého chovu? Odesláním formuláře níže se zařadíte do fronty zájemců. Budete informováni o dostupných mláďatech mezi prvními a získáte přednostní právo na výběr.",
      formTitle: "Poptávkový formulář",
      firstName: "Jméno",
      lastName: "Příjmení",
      email: "E-mail",
      phone: "Telefon",
      country: "Stát",
      speciesTitle: "Druhy, o které máte zájem",
      zebraFinch: "Zebřička pestrá",
      silverBill: "Stříbrozobka zpěvná",
      lovebird: "Agapornis škraboškový",
      regentParrot: "Papoušek horský",
      speciesOther: "Jiné",
      message: "Zpráva",
      messagePlaceholder: "Upřesněte mutace, pohlaví, počet, termín odběru apod.",
      gdprConsent: "Odesláním formuláře souhlasíte se zpracováním osobních údajů za účelem vyřízení poptávky.",
      gdprLink: "Zásady ochrany osobních údajů",
      submit: "Odeslat poptávku",
      sending: "Odesílám...",
      successTitle: "Poptávka odeslána!",
      successText: "Děkuji za váš zájem. Ozvu se vám co nejdříve.",
      faqTitle: "Nejčastější otázky",
      faq: [
        { q: "Mohu si ptáky zamluvit?", a: "Ano, ptáky je možné si zamluvit dopředu. Můžete si tak zamluvit například kombinaci, jež potřebujete. Při zamluvení ptáků, kteří jsou již k odběru, bude požadována nevratná zálohadle doby zamluvení." },
        { q: "Je možné ptáky někam doručit?", a: "Je možné se domluvit na dopravení kurýrem na jeho odběrná místa, či na burzy, pokud zrovna jedou. Převzetí je možné i na větších českých výstavách." },
        { q: "Mohu dostat slevu?", a: "Ano, při větším odběru a při odběru párů poskytuji slevy v závislosti na množství a druzích ptáků." },
        { q: "Musím mít vlastní přenosku?", a: "Odběr do vlastních přenosek upřednostňuji. Při odběru zebřiček či holoubků mohu poskytnout krabičku odpovídajících rozměrů. Při odběru papoušků je třeba mít přenosku vlastní." },
        { q: "Jak je určována cena nabízeného ptactva?", a: "Cena se prvotně odvíjí od druhu a následně od mutace, či kombinace. Vzhledem k tomu, že se věnuji i výstavnímu chovatelství, je cena ovlivněna také kvalitou podle standardu. Ač se mohou některé ceny zdát přemrštěné, tak se vždy snažím, aby odpovídaly danému jedinci. Ceny se také odvíjí od nákladů na kvalitní péči a krmení." },
        { q: "Co když mi pták od Vás uhyne?", a: "Rozhodně je tato situace výjimkou, která se však může stát třeba ze stresu při přepravě nebo z nového prostředí. Ke vzniklé škodě přistupuji vždy individuálně a po potvrzení úmrtí, do dvou týdnů po převzetí ptáků, je možné se domluvit na vrácení peněz či odpovídající náhradě." },
      ],
      contactTitle: "Kontakt",
      contactText: "Máte další otázky? Neváhejte mě kontaktovat přímo:",
    },
    community: {
      label: "Komunita",
      title1: "Přidej se ke",
      title2: "komunitě",
      description: "Zanechte svůj e-mail a dozvíte se o novinkách z mého chovu jako první! Získejte 20 tipů pro bezpečný nákup nového jedince do chovu.",
      benefits: ["Exkluzivní články a tipy na chov", "Pozvánky na přednášky a akce", "Přístup do komunity chovatelů"],
      placeholder: "tvuj@email.cz",
      subscribe: "Odebírat",
      consent: "Odesláním souhlasíte se zasíláním novinek z mého chovu. Odhlásit se můžete kontaktováním přes e-mail.",
    },
    footer: {
      tagline: "Exotic Bird Breeding",
      roles: "Chovatel · Posuzovatel · Cestovatel",
      contact: "Kontakt",
      follow: "Sledujte mě",
      copyright: "Všechna práva vyhrazena.",
    },
  },
  en: {
    nav: {
      about: "About",
      
      achievements: "Achievements",
      blog: "Blog",
      lectures: "Lectures",
      sales: "Sales",
      partners: "Partners",
      zebbie: "ZEBBIE",
      community: "Community",
      subscribe: "Subscribe",
    },
    hero: {
      subtitle: "Breeder · Judge · Traveller",
      description: "\"Breeding is in my genes!\" The world of exotic birds is my passion. I breed, judge, travel and share experiences from around the globe.",
      cta: "Join the community",
      more: "More about me",
    },
    about: {
      label: "About me",
      title1: "More than 16 years",
      title2: "among birds",
      p1: "I'm Tomáš Strachota — an exotic bird breeder, show judge and passionate traveller. I specialise in breeding exhibition Zebra Finches in various mutations, and my collection is always complemented by a few other species. Currently these are African Silverbills, which are experiencing a real boom thanks to the range of mutations and combinations available, Masked Lovebirds, which have returned to my aviaries after several years, and Regent Parrots.",
      p2: "Zebra Finches entered my breeding in 2014, three years after building my first aviaries. I was bothered that my previous birds were mainly about raising chicks and selling them without any clear goal. A series of articles about exhibition Zebra Finches got me hooked, and I gradually grew from four pairs to about 30 breeding cages and several aviaries.",
      p3: "In October 2025 I flew off to fulfil a dream in Australia, where my goal is to see as many species as possible in the wild. My travels around Australia have given me a unique insight into the lives of exotic birds in their natural environment. During my year-long stay I'll visit every Australian state, and my notes from the road are being published in magazines and here on the website in the Blog section.",
      p4: "I regularly contribute to Nová Exota magazine and other publications, collaborate with the Birdifly platform and I'm an ambassador for the Ornity.cz e-shop and the BirdSupreme brand.",
    },
    achievements: {
      label: "Achievements",
      title1: "Breeding",
      title2: "milestones",
      stats: [
        { value: "16+", label: "Years of experience" },
        { value: "1000+", label: "Chicks bred" },
        { value: "15+", label: "Species kept" },
        { value: "30+", label: "Shows attended" },
      ],
      highlights: [
        { title: "Breeder", description: "I have been dedicated to exotic birds since 2011, when at the age of eleven I started breeding lovebirds and Australian parakeets. Since then, aviculture has been part of my everyday life." },
        { title: "Judge", description: "Building on my show successes and desire to keep learning, I completed a judging course and since 2024 I have been attending shows in the Czech Republic and abroad as a judge." },
        { title: "Traveller", description: "Visiting breeders and travelling to shows and fairs across Europe — and the drive to follow my dreams — led to my year-long trip to Australia and New Zealand. I share my experiences through lectures and articles." },
      ],
    },
    blog: {
      label: "Blog",
      title1: "Latest",
      title2: "articles",
      allArticles: "All articles",
      read: "Read",
    },
    lectures: {
      label: "Lectures",
      title1: "Where we",
      title2: "meet",
      orderLecture: "Book a lecture",
      noUpcoming: "There are currently no public lectures scheduled. Follow this page or subscribe to the newsletter so you don't miss any upcoming dates.",
      items: [] as { title: string; description: string; location: string; date: string }[],
    },
    media: {
      label: "Media",
      title1: "Interviews &",
      title2: "features",
      view: "View",
    },
    partners: {
      label: "Partners",
      title1: "Projects &",
      title2: "partners",
      visit: "Visit",
    },
    sales: {
      label: "Sales",
      title1: "Bird",
      title2: "inquiry",
      heroText: "Interested in youngsters from my breeding? By submitting the form below, you'll join the waiting list. You'll be among the first to know about available youngsters and get priority selection.",
      formTitle: "Inquiry form",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      country: "Country",
      speciesTitle: "Species you are interested in",
      zebraFinch: "Zebra Finch",
      silverBill: "Silverbill",
      lovebird: "Lovebird (Masked)",
      regentParrot: "Regent Parrot",
      speciesOther: "Other",
      message: "Message",
      messagePlaceholder: "Specify mutations, sex, quantity, collection date, etc.",
      gdprConsent: "By submitting this form, you agree to the processing of your personal data for the purpose of handling this inquiry.",
      gdprLink: "Privacy policy",
      submit: "Submit inquiry",
      sending: "Sending...",
      successTitle: "Inquiry submitted!",
      successText: "Thank you for your interest. I will get back to you as soon as possible.",
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "Can I reserve birds in advance?", a: "Yes, you can reserve birds in advance. For example, you can reserve a specific combination you need. When reserving birds that are already available, a non-refundable deposit will be required depending on the reservation period." },
        { q: "Can you deliver birds?", a: "It is possible to arrange delivery via courier to their pick-up points, or to fairs if they are running. Pick-up is also possible at major Czech exhibitions." },
        { q: "Can I get a discount?", a: "Yes, I offer discounts for larger orders and pair purchases, depending on the quantity and species of birds." },
        { q: "Do I need my own carrier?", a: "I prefer birds to be collected in your own carrier. For zebra finches or diamond doves, I can provide a box of appropriate size. For parrots, you need to bring your own carrier." },
        { q: "How is the price determined?", a: "The price primarily depends on the species and then on the mutation or combination. Since I also engage in exhibition breeding, the price is also influenced by quality according to the standard. Although some prices may seem high, I always try to ensure they reflect the individual bird. Prices also account for the costs of quality care and feeding." },
        { q: "What if a bird I bought from you dies?", a: "This is definitely an exceptional situation, but it can happen due to stress during transport or a new environment. I approach each case individually, and after confirmed death within two weeks of pick-up, we can arrange a refund or appropriate replacement." },
      ],
      contactTitle: "Contact",
      contactText: "Have more questions? Don't hesitate to contact me directly:",
    },
    community: {
      label: "Community",
      title1: "Join the",
      title2: "community",
      description: "Leave your email and be the first to know about news from my breeding! Get 20 tips for safely purchasing a new bird.",
      benefits: ["Exclusive articles and breeding tips", "Lecture and event invitations", "Access to the breeder community"],
      placeholder: "your@email.com",
      subscribe: "Subscribe",
      consent: "By sending you agree to receive news from my breeding. You can unsubscribe by contacting me via e-mail.",
    },
    footer: {
      tagline: "Exotic Bird Breeding",
      roles: "Breeder · Judge · Traveller",
      contact: "Contact",
      follow: "Follow me",
      copyright: "All rights reserved.",
    },
  },
} as const;

export type Translations = (typeof translations)[Locale];
